import { motion } from "framer-motion";

const container = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.045, delayChildren: 0.15 },
  },
};

const letter = {
  hidden: { opacity: 0, y: 40, rotateX: 45 },
  show: {
    opacity: 1,
    y: 0,
    rotateX: 0,
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
  },
};

export const KineticHeadline = ({ text, className = "", testId }) => {
  const letters = text.split("");
  return (
    <motion.h1
      data-testid={testId}
      className={className}
      variants={container}
      initial="hidden"
      animate="show"
      aria-label={text}
    >
      {letters.map((ch, i) => (
        <motion.span
          key={i}
          variants={letter}
          className="inline-block"
          style={{ whiteSpace: ch === " " ? "pre" : "normal" }}
        >
          {ch}
        </motion.span>
      ))}
    </motion.h1>
  );
};
